/* ============
 * Admin Groups Mutations Types
 * ============
 *
 * The mutations types available for the admin-groups module.
 */

export const ALL = 'ALL';
export const NONE = 'NONE';
export const CREATED = 'CREATED';
export const UPDATED = 'UPDATED';
export const DESTROYED = 'DESTROYED';



// WEBPACK FOOTER //
// ./src/store/modules/admin-groups/types.js